import { AmountDelta, DeltaTypeEnum, UpgradeTarget } from "../domain/upgradeConfiguration.schema";

export function formatDate(d: Date | string): string {
  const date = d instanceof Date ? d : new Date(d);
  if (isNaN(date.getTime())) return String(d);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatDateRanges(ranges?: { start: Date | string; end: Date | string }[]): string {
  if (!ranges || ranges.length === 0) return "-";
  return ranges.map(r => `${formatDate(r.start)} / ${formatDate(r.end)}`).join(", ");
}

export function getBaseTicker(target: UpgradeTarget): string {
  return target.baseAccommodationTicker || target.baseMealPlanTicker || "";
}

export function formatDelta(delta: AmountDelta): string {
  if (delta.deltaType === DeltaTypeEnum.PERCENTAGE && typeof delta.value === "number") {
    return `${delta.value}%`;
  }
  if (delta.deltaType === DeltaTypeEnum.MONETARY_AMOUNT && typeof delta.value === "object") {
    return `${delta.value.amount} ${delta.value.currency}`;
  }
  return "-";
}
